import lodash from 'lodash'

export const maxCpeLines = 100000

const imeiPattern = /^[A-Za-z0-9]{6,50}$/

/**
 * @param {string} inputText
 * @param {{ mode?: 'import' | 'sn' }} options
 *   - import: 入库，每行 SN 必填；可选 SN|IMEI|IMEI（支持 1 或 2 个 IMEI）
 *   - sn: 划拨，每行仅 SN（若带 | 则取第一段）
 */
export function analyzeCpes(inputText, options = {}) {
  const mode = options.mode === 'import' ? 'import' : 'sn'
  const lines = inputText.split(/\r?\n/)
  const totalLines = lines.length
  if (totalLines > maxCpeLines) {
    return { lines: totalLines, validCpes: [], errorText: '' }
  }

  const validCpes = []
  let errorText = ''

  lines.forEach((line) => {
    const value = lodash.trim(line)
    if (!value) {
      return
    }

    if (mode === 'import') {
      const parts = value.split('|')
      const sn = lodash.trim(parts[0])
      const imei1 = parts.length > 1 ? lodash.trim(parts[1]) : ''
      const imei2 = parts.length > 2 ? lodash.trim(parts[2]) : ''

      if (!sn) {
        errorText += `${value}（SN不能为空）\n`
        return
      }
      if (parts.length > 3) {
        errorText += `${value}（格式错误，应为 SN 或 SN|IMEI 或 SN|IMEI|IMEI）\n`
        return
      }
      if (!imei1 && imei2) {
        errorText += `${value}（请先填写IMEI1）\n`
        return
      }
      if (imei1 && !imeiPattern.test(imei1)) {
        errorText += `${value}（IMEI1格式错误）\n`
        return
      }
      if (imei2 && !imeiPattern.test(imei2)) {
        errorText += `${value}（IMEI2格式错误）\n`
        return
      }
      if (imei1 && imei2 && imei1 === imei2) {
        errorText += `${value}（两个IMEI不能相同）\n`
        return
      }

      validCpes.push({ sn, imei1, imei2 })
      return
    }

    const sn = lodash.trim(value.split('|')[0])
    if (!sn) {
      errorText += `${value}（SN不能为空）\n`
      return
    }
    validCpes.push({ sn, imei1: '', imei2: '' })
  })

  return { lines: totalLines, validCpes, errorText }
}

export function formatCpeInputValue(cpes, mode = 'sn') {
  if (!cpes || cpes.length === 0) {
    return ''
  }

  if (mode === 'import') {
    return cpes.map((item) => {
      if (!item.imei1 && !item.imei2) {
        return item.sn
      }
      if (!item.imei2) {
        return [item.sn, item.imei1 || ''].join('|')
      }
      return [item.sn, item.imei1 || '', item.imei2 || ''].join('|')
    }).join('\n')
  }

  return cpes.map((item) => item.sn).join('\n')
}
